import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formatDate } from 'react-day-picker/moment';
import { isNullOrUndefined, openInNewWindow } from '../../store/storeFunctions';
import { isOnPath } from '../../store/apiWrapper';
import { Link } from 'react-router-dom';
import { popupActions } from '../../store/popupStore';
import { rightPanelItems, rightPanelStoreActions } from '../../store/rightPanelStore';
import { searchActions } from '../../store/searchStore';
import { Translate, withLocalize } from 'react-localize-redux';
import HelpManager from '../common/helpManager';

import FilterIcon from '../../img/icons/BBicons_Filtr';
import PinIcon from '../../img/icons/BBicons_Pin';
import PortfolioIcon from '../../img/icons/BBiconsPridatDoPortfolia';
import SvgBBiconsBmAml from '../../img/icons/leftPanel/BBiconsBmAml';
import SvgBBiconsBmExekuceCz from '../../img/icons/leftPanel/BBiconsBmExekuceCz';
import SvgBBiconsBmExekuceSk from '../../img/icons/leftPanel/BBiconsBmExekuceSk';
import SvgBBiconsBmNemovitostiCz from "../../img/icons/leftPanel/BBiconsBmNemovitostiCz";
import SvgBBiconsBmNemovitostiSk from "../../img/icons/leftPanel/BBiconsBmNemovitostiSk";
import SvgBBiconsFiltr from '../../img/icons/BBicons_Filtr';
import SvgBBiconsNaposledyProhlizene from '../../img/icons/BBicons_Naposledy_prohlizene';
import SvgBBiconsPdfSettings from '../../img/icons/BBicons_PDFsettings';
import SvgBBiconsPin from '../../img/icons/BBicons_Pin';
import SvgBBiconsSekce from '../../img/icons/BBicons_Sekce';
import SvgBBiconsSpravovatPortfolio from '../../img/icons/BBicons_Spravovat_portfolio';
import WarningIcon from '../../img/icons/BBiconsVi';

class RightPanelOpener extends React.Component {
    _rightPanelItems = {
        'last-searched': { icon: SvgBBiconsNaposledyProhlizene, title: 'Search.LastSubjects' },
        // 'chart-settings': { icon: FilterIcon, title:'Report.Settings.Title' },
        'subject-clipboard': { icon: SvgBBiconsPin, title: 'Search.Clipboard' },
        'report-settings': { icon: SvgBBiconsSpravovatPortfolio, title: 'Report.Settings.Title' },
        'report-filters': { icon: SvgBBiconsFiltr, title: 'Common.Filter' },
        'sections-config': { icon: SvgBBiconsSekce, title: 'Report.Sections' },
        'sections-pdf-export': { icon: SvgBBiconsPdfSettings, title: 'Report.Sections.PdfExport' },
        'search-filter': { icon: FilterIcon, title: 'Search.Filter.Title' },
        'alerts-filter': { icon: FilterIcon, title: 'Common.Filter' },
        'unicorn-sections': { icon: SvgBBiconsSpravovatPortfolio, title: 'Marketing.Add.Remove.Criteria' },
        'unicorn-export-sections': { icon: SvgBBiconsSpravovatPortfolio, title: 'Marketing.AddParameters' },
        'help-redirect': { body: HelpManager }
    }

    render() {
        const toRender = [];
        let items = this.getVisibleItems().map(x => {
            if (x.customHandler === true) {
                const Handler = x.body;
                return <Handler key={x.id} itemKey={x.id} inMobileMenu={true} />
            }
            let OpenerIcon = x.icon;
            return this.renderItem(x.id, OpenerIcon, x.title, () => this.props.toggleRightPanel(true, x.id));
        });

        if (isOnPath({ regex: /\/(((report)\/([\w-]+))|(relation-chart))\/(\d+).*/i }) || isOnPath({ regex: /(unlimited\/quick)/i })) {
            const entityInfo = (this.props.entityIdents.entityInfos[this.props.report.id] || {}).result;
            if (entityInfo !== undefined && entityInfo !== null) {
                if ((entityInfo.reports || {}).NI) {
                    items.push(this.renderItem('warnings', WarningIcon, 'Report.Warnings.SectionName', () => openInNewWindow(`/warnings/${this.props.report.id}`, this.props.translate("Report.Warnings.SectionName"))));
                }

                items.push(this.renderItem('add-to-portfolio', PortfolioIcon, 'Common.AddToPortfolio', () => this.openPortfolioPopup(entityInfo)));

                if (this.isInClipboard(this.props.report.id)) {
                    items.push(this.renderItem('remove-from-clipboard', PinIcon, 'Search.Clipboard.AlreadyIn', () => this.props.removeFromClipboard(entityInfo, this.props.translate('Search.Clipboard.SubjectRemoved'))));
                } else {
                    items.push(this.renderItem('add-to-clipboard', PinIcon, 'Search.Clipboard.Add', () => this.props.addToClipboard(entityInfo, this.props.translate('Search.Clipboard.SubjectAdded'))));
                }

                if (entityInfo.type === 2 || (entityInfo.type === 1 && entityInfo.reports && entityInfo.reports.primaryAttr === 1)) {
                    items.push(this.renderLink('cee-search', SvgBBiconsBmExekuceCz, 'Report.AdvanceInformation.Cee', { pathname: '/search/cee/subject', search: this.createOdQueryString(entityInfo, false, true) }));
                }
                if (entityInfo.type === 2 || (entityInfo.type === 1 && entityInfo.reports && entityInfo.reports.primaryAttr === 1)) {
                    items.push(this.renderLink('property-cz-search', SvgBBiconsBmNemovitostiCz, 'Report.AdvanceInformation.PropertyCz', { pathname: '/search/property-cz', search: this.createOdQueryString(entityInfo, true) }));
                }
                if (entityInfo.type === 2 || (entityInfo.type === 1 && entityInfo.reports && entityInfo.reports.primaryAttr === 2)) {
                    items.push(this.renderLink('cre-search', SvgBBiconsBmExekuceSk, 'Report.AdvanceInformation.Cre', { pathname: '/search/cre/subject', search: this.createOdQueryString(entityInfo, true) }));
                }
                if (entityInfo.type === 2) {
                    items.push(this.renderLink('property-sk-search', SvgBBiconsBmNemovitostiSk, 'Report.AdvanceInformation.PropertySk', { pathname: '/search/property-sk', search: this.createOdQueryString(entityInfo, false) }));
                }
                if (entityInfo.type === 2 || (entityInfo.type === 1 && entityInfo.reports && entityInfo.reports.primaryAttr === 3)) {
                    items.push(this.renderLink('aml-search', SvgBBiconsBmAml, 'Report.AmlInfoCheck.SectionName', { pathname: '/search/aml/subject', search: this.createOdQueryString(entityInfo, true) }));
                }
            }
        }

        for (let idx = 0; idx < items.length; idx++) {
            toRender.push(items[idx]);
            if (idx < items.length - 1) {
                toRender.push(<hr key={`divider-${idx}`} className="navbar-divider"></hr>)
            }
        }
        return toRender;
    }

    renderLink = (keyId, Icon, text, linkTo) => {
        return <Link key={keyId} className='navbar-item' to={linkTo} target={"_blank"}>
            <div className='icon-holder'><div className='icon-wrap'><Icon /></div></div>
            <div className='text-wrapper'><div className='text'><span className='span-wrapper'><Translate id={text} /></span></div></div>
        </Link>
    }

    renderItem = (keyId, Icon, text, onClick) => {
        return <a key={keyId} className='navbar-item' onClick={onClick}>
            <div className='icon-holder'><div className='icon-wrap'><Icon /></div></div>
            <div className='text-wrapper'><div className='text'><span className='span-wrapper'><Translate id={text} /></span></div></div>
        </a>
    }

    createOdQueryString = (entityInfo, isSurname, entrepreneur) => {
        if (isNullOrUndefined(entityInfo) && isNullOrUndefined(entityInfo.queryName) && isNullOrUndefined(entityInfo.dateOfBirth))
            return "";

        let query = `?`;
        if (entityInfo.type === 1) {
            if (entityInfo.reports && entityInfo.reports.primaryAttr === 3)
                query += `companyName=${encodeURIComponent(entityInfo.queryName)}`;
            else {
                if (entrepreneur && entityInfo.entrepreneur === true)
                    query += `entrepreneurId=${entityInfo.entityId}`;
                else
                    query += `companyId=${encodeURIComponent(entityInfo.ico)}`;
            }                
        } else {
            if (!isNullOrUndefined(entityInfo.queryName))
                if (isSurname) {
                    var parts = entityInfo.queryName.split(" ");
                    query += `name=${encodeURIComponent(parts.slice(0, parts.length - 1).join(" "))}`;
                    query += `&surname=${encodeURIComponent(parts[parts.length - 1])}`;
                }
                else
                    query += `name=${encodeURIComponent(entityInfo.queryName)}`;
            if (!isNullOrUndefined(entityInfo.dateOfBirth))
                query += `&birthDate=${encodeURIComponent(formatDate(entityInfo.dateOfBirth, 'YYYY-MM-DD', 'cs'))}`;
        }
        return query;
    }

    getVisibleItems = () => {
        const panelItems = rightPanelItems.map(x => { return { ...x, ...this._rightPanelItems[x.id] } });
        return panelItems.filter(r => r.visible(this) && ((r.icon !== null && r.icon !== undefined) || r.customHandler));
    }

    openPortfolioPopup = (subject) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }

    isInClipboard = (entityId) => {
        return this.props.search.clipboard.filter(x => x.entityId === entityId).length === 1
    }
}

export default withLocalize(connect(
    state => { return { layout: state.layout, entityIdents: state.entityIdentRow, report: state.report, search: state.search } },
    dispatch => bindActionCreators({ ...rightPanelStoreActions, ...popupActions, ...searchActions }, dispatch)
)(RightPanelOpener));